import { FC } from "react";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";

import { MDSPanelHeader, MDSPanelHeaderSlotName, MDSText, MDSTextVariant } from "@/mds";
import { PageBannerSection } from "@/components/banners/page-banner-section";

type Props = Record<string, never>;

export const AudioRecordingsListPageHeader: FC<Props> = observer(() => {
  return (
    <Wrapper>
      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Audio Recordings
        </MDSText>
      </MDSPanelHeader>
      <PageBannerSection />
    </Wrapper>
  );
});

const Wrapper = styled.div``;
